import { useState } from 'react';
import CreateForTaskDialog from './CreateForTaskDialog';
import LinkFileDialog from './LinkFileDialog';
import StartVideoDialog from './StartVideoDialog';
import { linkResultLine } from './taskUi';

/** The dialogs that give a waiting task its file, or start its video again. */
const TaskFileDialogs = ({
    task,
    detail,
    waiting,
    canStartVideo,
    videoFailed,
    linking,
    setLinking,
    creatingFile,
    setCreatingFile,
    startingVideo,
    setStartingVideo,
    onRefreshed,
    setSnack,
}) => {
    const [newFile, setNewFile] = useState(null);
    return (
        <>
            {waiting && detail.plan && (
                <LinkFileDialog
                    open={linking}
                    task={task}
                    plan={detail.plan}
                    file={newFile}
                    onClose={() => {
                        setLinking(false);
                        setNewFile(null);
                    }}
                    onLinked={(result, { keepOpen, message } = {}) => {
                        onRefreshed();
                        if (keepOpen) return;
                        setLinking(false);
                        setNewFile(null);
                        setSnack({ message });
                    }}
                />
            )}
            {creatingFile && waiting && detail.plan && (
                <CreateForTaskDialog
                    task={task}
                    plan={detail.plan}
                    onClose={() => setCreatingFile(false)}
                    onCreated={(file) => {
                        setNewFile({ contentId: file.id, title: file.name || task.contentTitle });
                        setLinking(true);
                    }}
                />
            )}
            {(canStartVideo || videoFailed) && (
                <StartVideoDialog
                    open={startingVideo}
                    task={task}
                    plan={detail.plan}
                    again={videoFailed}
                    startedVideo={detail.startedVideo}
                    onClose={() => setStartingVideo(false)}
                    onStarted={(result) => {
                        onRefreshed();
                        setStartingVideo(false);
                        const partial = result.failed?.length > 0 ? ` ${linkResultLine(result, 'VIDEO')}` : '';
                        const missing =
                            result.notOnVideo?.length > 0
                                ? ` ${result.notOnVideo.join(' and ')} isn't on the video yet.`
                                : '';
                        setSnack({ message: `${result.name} is processing.${partial}${missing}` });
                    }}
                />
            )}
        </>
    );
};

export default TaskFileDialogs;
